import React from 'react';
import Image from 'next/image';
import Button from 'seedly-component-library/button-new';
import { imageUrl } from 'theme';
import buildConfig from 'utils/buildConfig';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import IconWrapper from './IconWrapper';

interface OwnProps {
  title?: string;
  trackingParam?: string;
  isSignup?: boolean;
  isIconOnly?: boolean;
}

const FacebookLoginButton = ({
  title = 'Continue with Facebook',
  trackingParam,
  isSignup = false,
  isIconOnly,
}: OwnProps) => {
  const handleButtonClick = () => {
    if (trackingParam) {
      mixpanel.track(trackedEvents.LoginSignUpModal, {
        param: trackingParam,
      });
    }
    const redirectUrl = window.location.href;
    if (isSignup) {
      sessionStorage.setItem('user-signedup', 'true');
    }
    window.location.href = `${buildConfig.apiDomain}/auth/facebook?origin=${redirectUrl}`;
  };

  if (isIconOnly) {
    return (
      <IconWrapper
        className="bg-blue-500 border-blue-500"
        onClick={handleButtonClick}
      >
        <Image width={20} height={20} src={imageUrl.facebook} loading="lazy" />
      </IconWrapper>
    );
  }

  return (
    <Button
      onClick={handleButtonClick}
      isBlock
      size="lg"
      className="align-middle bg-facebook"
    >
      <div className="flex items-center gap-2">
        <Image width={20} height={20} src={imageUrl.facebook} loading="lazy" />
        <p className="text-sm font-semibold text-white">{title}</p>
      </div>
    </Button>
  );
};

export default FacebookLoginButton;
